import React from "react";
import {Pane} from "evergreen-ui";

export default function EvaporationTable() {

    const tableStyle = {
        tableLayout: "fixed",
        width: "1600px",
        borderCollapse: "collapse",
        marginBottom: "90px",
        fontFamily: "\"SF UI Text\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\""
    }

    const createTable = () => {

      return (
          <table border={"1px"} style={tableStyle}>
            <tr>
              <th colSpan={1}>Дата, месяц</th>
              <th colSpan={2}>Срок расчета испарения</th>
              <th colSpan={3}>Испарение, мм</th>
              <th colSpan={4}>Температура воды, °С</th>
              <th colSpan={5}>Скорость ветра, м/с</th>
              <th colSpan={6}>Давление насыщенного водяного пара, гПа</th>
            </tr>
          </table>
      );
    }



    return (
        <>
            <Pane marginTop={30}><h3>Выходная таблица наблюдений</h3></Pane>
            <Pane marginTop={30} width={1100}>
                {createTable()}
            </Pane>
        </>
    )
}